export const TELECONSULTATION_MODES = {
  DEFAULT: "Default (just link)",
  MYDOC: "MyDoc (invite id generation)",
};
